export { default } from "./DeleteResponder";
export * from "./DeleteResponder";
